import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'split-inside-menu',
  templateUrl: './split-inside-menu.component.html',
  styleUrls: ['./split-inside-menu.component.scss'],
})
export class SplitInsideMenuComponent {
  currentInternalIndex: number = 0;

  @Input() data: Array<{ title: string; icon: string }> = [];
  @Input() itemWidth: string = ''
  @Output() currentIndex = new EventEmitter<number>();

  emitEvent(index: number) {
    this.currentInternalIndex = index;

    this.currentIndex.emit(index);
  }
}
